import { reducerInit } from "../../api/dbselect.js"

const init = reducerInit("orderinfo")

export const orderInfoReducer = (state = init, action) => {
	switch (action.type) {
		case "INSERT_ORDERINFO":
			return [...state, action.data]

		case "UPDATE_ORDERINFO":
			return state.map((object, i) => {
				let newObject = JSON.parse(JSON.stringify(object))
				if (newObject.orderinfoid === action.id) {
					for (const data in action.json) {
						newObject[data] = action.json[data]
					}
					return newObject
				} else {
					return newObject
				}
			})

		case "DELETE_ORDERINFO":
			return state.filter((object) => object.orderinfoid !== action.id)

		default:
			return state
	}
}
